import Snackbar from '@material-ui/core/Snackbar';
import * as React from 'react';
import { ToastMessage } from '../../models/utilities/toast-message';

import './ToastNotification.scss';

// #region Component State

const initialState = {
    open: false
};

type State = Readonly<typeof initialState>;

// #endregion

// #region Component Props

interface IProps {
    toast       : ToastMessage;
    toastIdx    : number;
    onDismiss   : any;
}

// #endregion

class ToastNotification extends React.Component<IProps, State> {

    public state: State = initialState;

    public componentDidMount() {
        this.setState({
            open: true
        });
    }

    public handleClose = (event: any) => {
        this.setState({ 
            open: false 
        }, () => this.props.onDismiss(this.props.toastIdx));
    }

    public render() {
        const { toast }  = this.props;

        return (
            <div>
                <Snackbar
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left'
                    }}
                    className={'toast-msg toast-msg-' + toast.msgType }
                    open={this.state.open}
                    autoHideDuration={toast.durationMs ?? 6000}
                    onClose={this.handleClose}
                    ContentProps={{
                        'aria-describedby': 'message-id'
                    }}
                    message={<span id="message-id">{ toast.message}</span>}
                    action={[
                        <button
                            key="close"
                            onClick={this.handleClose}
                            className="btn-icon">
                            <i className="la la-close" />
                        </button>
                    ]}
                />
            </div>
        );
    }
}

export { ToastNotification };
